import { CALL_API } from '../middleware/ApiMiddleware';

export const FORM_LIST_FETCH_REQUEST = 'FORM_LIST_FETCH_REQUEST';
export const FORM_LIST_FETCH_SUCCESS = 'FORM_LIST_FETCH_SUCCESS';
export const FORM_LIST_FETCH_FAILURE = 'FORM_LIST_FETCH_FAILURE';

export const FORM_FETCH_REQUEST = 'FORM_FETCH_REQUEST';
export const FORM_FETCH_SUCCESS = 'FORM_FETCH_SUCCESS';
export const FORM_FETCH_FAILURE = 'FORM_FETCH_FAILURE';

export const FORM_EDIT_REQUEST = 'FORM_EDIT_REQUEST';
export const FORM_EDIT_SUCCESS = 'FORM_EDIT_SUCCESS';
export const FORM_EDIT_FAILURE = 'FORM_EDIT_FAILURE';

export const FORM_CREATE_REQUEST = 'FORM_CREATE_REQUEST';
export const FORM_CREATE_SUCCESS = 'FORM_CREATE_SUCCESS';
export const FORM_CREATE_FAILURE = 'FORM_CREATE_FAILURE';

export const FORM_EDIT_SEQUENCE_REQUEST = 'FORM_EDIT_SEQUENCE_REQUEST';
export const FORM_EDIT_SEQUENCE_SUCCESS = 'FORM_EDIT_SEQUENCE_SUCCESS';
export const FORM_EDIT_SEQUENCE_FAILURE = 'FORM_EDIT_SEQUENCE_FAILURE';

const formsURL = 'xerce/config/forms';

export const fetchForms = () => ({
  [CALL_API]: {
    endpoint: formsURL,
    method: 'get',
    authenticated: true,
    types: [FORM_LIST_FETCH_REQUEST, FORM_LIST_FETCH_SUCCESS, FORM_LIST_FETCH_FAILURE],
  },
});

export const fetchForm = (formId: number) => ({
  [CALL_API]: {
    endpoint: `${formsURL}/${formId}`,
    method: 'get',
    authenticated: true,
    types: [FORM_FETCH_REQUEST, FORM_FETCH_SUCCESS, FORM_FETCH_FAILURE],
  },
});

export const editForm = (formId: number, formEditRequest: IConfigXerceFormRequest) => ({
  [CALL_API]: {
    endpoint: `${formsURL}/${formId}`,
    method: 'put',
    body: formEditRequest,
    authenticated: true,
    types: [FORM_EDIT_REQUEST, FORM_EDIT_SUCCESS, FORM_EDIT_FAILURE],
  },
});

export const createForm = (formCreateRequest: IConfigXerceFormRequest) => ({
  [CALL_API]: {
    endpoint: formsURL,
    method: 'post',
    body: formCreateRequest,
    authenticated: true,
    types: [FORM_CREATE_REQUEST, FORM_CREATE_SUCCESS, FORM_CREATE_FAILURE],
  },
});

export const editFormSequence = (sequence: number[]) => ({
  [CALL_API]: {
    endpoint: `${formsURL}/sequence`,
    method: 'put',
    body: { sequence },
    authenticated: true,
    types: [FORM_EDIT_SEQUENCE_REQUEST, FORM_EDIT_SEQUENCE_SUCCESS, FORM_EDIT_SEQUENCE_FAILURE],
  },
});
